import { documentTypes } from '@/features/selectors';

export default {
  computed: {
    getDocumentsList() {
      return documentTypes;
    },
    getPrivilegeDocumentsList() {
      return this.$store.getters.CUSTOMER_PRIVILEGE;
    },
  },
  methods: {
    convertDocumentUidToId(uid) {
      if (!uid) return null;

      const document = documentTypes.find(doc => doc.uid === uid);
      return document ? document.id : null;
    },
    convertDocumentIdToUid(id) {
      if (!id) return null;

      const document = documentTypes.find(doc => doc.id === id);
      return document ? document.uid : null;
    },
    getDocumentByUid(uid) {
      if (!uid) return null;
      return documentTypes.find(doc => doc.uid === uid) || null;
    },
    getDocumentById(id) {
      if (!id) return null;
      return documentTypes.find(doc => doc.id === id) || null;
    },
    normalizeDocumentValue(value) {
      if (!value) return null;

      if (typeof value === 'object') {
        return value.id || null;
      }

      if (typeof value === 'number') {
        return this.convertDocumentUidToId(value);
      }

      return value;
    },
    getPrivilegeDocumentByUid(uid) {
      if (!uid) return null;

      return this.getPrivilegeDocumentsList.find(doc => doc.documentUid === uid) || null;
    },
    getPrivilegeDocumentById(id) {
      if (!id) return null;

      return this.getPrivilegeDocumentsList.find(doc => doc.id === id) || null;
    },
  },
};
